import { hasAdvertisementConsent } from "./cookieConsent";

const META_PIXEL_ID =
  process.env.REACT_APP_META_PIXEL_ID?.trim() || "1529968015359495";

let initialized = false;

function ensureMetaPixelBase(): void {
  if (typeof window === "undefined" || !META_PIXEL_ID || typeof document === "undefined") {
    return;
  }

  if (!window.fbq) {
    const fbq = function (...args: unknown[]) {
      (fbq as unknown as { queue: unknown[] }).queue.push(args);
    } as unknown as ((...args: unknown[]) => void) & {
      queue: unknown[];
      callMethod?: (...args: unknown[]) => void;
      loaded?: boolean;
      version?: string;
      push?: (...args: unknown[]) => void;
    };
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.push = (...args: unknown[]) => fbq(...args);
    window.fbq = fbq;
    window._fbq = fbq;

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    const firstScript = document.getElementsByTagName("script")[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
  }

  if (!initialized) {
    window.fbq?.("init", META_PIXEL_ID);
    initialized = true;
  }
}

function withAdConsent(callback: () => void): void {
  if (!hasAdvertisementConsent()) return;
  ensureMetaPixelBase();
  callback();
}

export function trackMetaPageView(): void {
  withAdConsent(() => {
    window.fbq?.("track", "PageView");
  });
}

export function trackMetaViewContent(payload: {
  content_ids: string[];
  content_name: string;
  content_type: "product";
  value: number;
  currency: string;
}): void {
  withAdConsent(() => {
    window.fbq?.("track", "ViewContent", payload);
  });
}

export function trackMetaAddToCart(payload: {
  content_ids: string[];
  content_name: string;
  content_type: "product";
  value: number;
  currency: string;
}): void {
  withAdConsent(() => {
    window.fbq?.("track", "AddToCart", payload);
  });
}

export function trackMetaPurchase(payload: {
  value: number;
  currency: string;
  content_ids: string[];
  content_type: "product";
  order_id: string;
}): void {
  withAdConsent(() => {
    window.fbq?.("track", "Purchase", payload);
  });
}
